module.exports = __webpack_public_path__ + "static/media/make-com.049a0240.svg";